function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Profile Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Components-/-Navigation-/-_Navigation",
  transform: "translate(-29.000000, -699.000000)",
  fill: "#06273A"
}, React.createElement("g", {
  id: "profile",
  transform: "translate(29.148936, 699.000000)"
}, React.createElement("path", {
  d: "M10,2.375 C10.9378222,2.375 11.8044056,2.87532215 12.2733167,3.68749998 C12.7422278,4.49967782 12.7422278,5.50032218 12.2733167,6.31250002 C11.8044056,7.12467785 10.9378222,7.625 10,7.625 C8.55025253,7.625 7.375,6.44974747 7.375,5 C7.375,3.55025253 8.55025253,2.375 10,2.375 L10,2.375 Z M10,13.625 C13.7125,13.625 17.625,15.45 17.625,16.25 L17.625,17.625 L2.375,17.625 L2.375,16.25 C2.375,15.45 6.2875,13.625 10,13.625 L10,13.625 Z M10,0 C7.2375,0 5,2.2375 5,5 C5,7.7625 7.2375,10 10,10 C12.7625,10 15,7.7625 15,5 C15,2.2375 12.7625,0 10,0 Z M10,11.25 C6.6625,11.25 0,12.925 0,16.25 L0,20 L20,20 L20,16.25 C20,12.925 13.3375,11.25 10,11.25 Z",
  id: "ProfileIcon"
}))));

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.01638621.svg";
export { ForwardRef as ReactComponent };